// extracted by mini-css-extract-plugin
export default {"modal-link":"_3k_Nw","modalLink":"_3k_Nw"};